export default __webpack_public_path__ + "static/media/bag-icon-white.ee963316.svg";